import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Container, Row, Button, Form, InputGroup, Spinner, Offcanvas } from "react-bootstrap";
import { zeroPad } from "react-countdown";
import "../../assets/css/component.css";
import CarouselLayout from "../../containers/Layouts/CarouselLayout/CarouselLayout";
import CarouselMultipleLayout from "../../containers/Layouts/CarouselLayout/CarouselMultipleLayout";
import CardUnit from "../../components/CardUnit/CardUnit";
import ConnectionLatency from "../../components/ConnectionLatency/ConnectionLatency";
import Time from "../../assets/icons/Time";
import Location from "../../assets/icons/Location";
import Coupon from "../../assets/icons/Coupon";
import imageCar from "../../assets/images/category-car.png";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { showBidErrorToast } from "../../utils/bidToast";
import { format } from "date-fns";
import CurrencyInput from "react-currency-input-field";
import ArtworkPending from "./ArtworkPending";
import PageNotFound from "../Errors/PageNotFound";
import { actionsLiveAuction } from "../../redux/liveAuction.slice";
import { userSelector } from "../../redux/auth.slice";
import { useDispatch, useSelector } from "react-redux";
import ResultLelang from "../../components/Modals/ResultLelang";
import withAuth from "../../services/withAuthProvider";
import SpecialNIPL from "../../assets/icons/SpecialNIPL";
import Warning from "../../assets/icons/Warning";
import LockOff from "../../assets/icons/lock_off";
import LockOn from "../../assets/icons/lock_on";
import { isDate } from "../../utils/string";
import moment from "moment";
import OnlineAuctionSkeleton from "../../components/Skeleton/OnlineAuctionSkeleton";
import * as io from "socket.io-client";
import UserIcon from "../../assets/icons/UserIcon";
import { TimerIcon, ProxyBidIcon } from "../../assets/icons/AuctionIcons";

// Import color constants for better maintainability
import {
  bidDisabledActive,
  bidDisabledInactive,
  textDark,
  textWhite,
  danger,
  socketConnected,
  socketReconnecting,
  socketDisconnected,
  socketError,
  socketUnknown,
} from "../../config/colors";
import { formatSimpleDateRange } from "../../helpers/dateRangeFormatter";
import NoImage from "../../assets/images/NoImage.jpg";

const defaultImage = NoImage;
const initialBid = {
  buyer: {},
  offer_price: 0,
  type: "-",
};

const initialDataModal = {
  lot_number: "",
  data_unit: {},
};

// Sama dengan pesan server (backend MsgBidLostRace)
const slowerBidder = "Anda Kalah Cepat!";
const niplOutOfStock = "NIPL anda telah habis";
const errorSendBidMessages = [
  slowerBidder,
  "NIPL anda telah habis",
  "Tidak Bisa Bid, kamu Sekarang Bidder Tertinggi!",
];

// Lazy Load Component for Lot Cards
const LazyLotCard = ({ item, auction, processUnitDetails, isVisible, onVisible }) => {
  const cardRef = useRef(null);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const currentRef = cardRef.current;
    if (!currentRef) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !shouldRender) {
            setShouldRender(true);
            onVisible?.();
          }
        });
      },
      {
        root: null,
        rootMargin: "200px", // Load 200px before entering viewport
        threshold: 0.01,
      }
    );

    observer.observe(currentRef);

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [shouldRender, onVisible]);

  const unitDetail = useMemo(() => {
    if (!shouldRender) return null;
    return processUnitDetails(item);
  }, [shouldRender, item, processUnitDetails]);

  return (
    <div ref={cardRef} style={{ padding: "0 8px" }}>
      {shouldRender ? (
        <CardUnit
          link={
            item?.auction?.is_exclusive
              ? `https://${item?.auction?.exclusive_seller_slug}.${window.location.hostname}/unit-lelang/${item.id}`
              : `/unit-lelang/${item.id}`
          }
          timeLocation={true}
          lot_number={`${auction?.auction_lane_name}${item?.lot_number}` || "-"}
          price={item?.base_price}
          tags={item?.tags || []}
          nama={item?.unit_name}
          location={item?.auction?.location_name}
          auction={auction}
          pictures={item?.pictures}
          grade={item?.unit_inspection?.grade}
          unitType={item?.unit_type?.name}
          unitDetail={unitDetail}
          specialNIPL={item?.number_of_nipl}
        />
      ) : (
        <div
          style={{
            minHeight: "350px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner animation="border" size="sm" variant="secondary" />
        </div>
      )}
    </div>
  );
};

export default function TimeBidAuctionGo() {
  const thisUser = useSelector(userSelector);
  const [SpecialNIPLToggle, setSpecialNIPLToggle] = useState({
    remaining_nipls: 0,
    used_nipls_this_stock_unit: 0,
    is_special_nipl: "false",
    number_of_nipl: 0,
  });

  const { id, unitId } = useParams();
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [result, setResult] = useState("LOADING");
  const [key, setKey] = useState(1);
  const [color, setColor] = useState("success");
  const [dataModal, setDataModal] = useState({ ...initialDataModal });
  const [totalNipl, setTotalNipl] = useState(0);

  // status
  const [disableBid, setDisabledBid] = useState("off");
  const [blockBid, setBlockBid] = useState("off");
  const [isProcess, setIsProcess] = useState("off");
  const [liveAuction, setLiveAuction] = useState("COMING");
  const [isSelectingWinner, setIsSelectingWinner] = useState(false);
  const shouldEmitTotalNipl = useRef(true); // Track if we should emit TotalNipl on next bid

  // list
  const [data, setData] = useState({});
  const [auction, setAuction] = useState({});
  const [images, setImages] = useState([]);
  const [nextLots, setNextLots] = useState([]);
  const [allNextLots, setAllNextLots] = useState([]); // Store all lots
  const [showAllLots, setShowAllLots] = useState(false); // Toggle for showing all lots
  const [biddingList, setBiddingList] = useState([]);
  const [proxyList, setProxyList] = useState([]);
  const [responErrorBid, setResponseErrorBid] = useState({
    offer_price: 0,
    response: null,
  });

  // bid
  const [offer, setOffer] = useState(0);
  const [error, setError] = useState("");
  const [highestBid, setHighestBid] = useState({ ...initialBid });
  const [multipleBid, setMultipleBid] = useState(0);
  const [counter, setCounter] = useState(null);

  // loader
  const [unitLoader, setUnitLoader] = useState(false);
  const [nextUnitLoader, setNextUnitLoader] = useState(false);
  const [bidLoader, setBidLoader] = useState(false);
  const [socketStatus, setSocketStatus] = useState("connecting");
  // Latency socket ke server (ms) dari ping/pong socket.io, untuk indikator koneksi.
  const [latencyMs, setLatencyMs] = useState(null);
  useEffect(() => {
    if (socketStatus !== "connected") setLatencyMs(null);
  }, [socketStatus]);
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const [maxReconnectReached, setMaxReconnectReached] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  const prevUnitId = useRef();
  const reconnectCountRef = useRef(0);
  const stableConnectionTimerRef = useRef(null);
  const joinRoomTimeoutRef = useRef(null);
  const lastRejoinOnErrorRef = useRef(0); // Track last rejoin timestamp to prevent infinite loop
  const REJOIN_COOLDOWN_MS = 10000; // 10 seconds cooldown between rejoins on error

  const URL = process.env.REACT_APP_SOCKET;
  const token = localStorage.getItem("token");
  const AccessToken = `Bearer ${token}`;
  const MAX_RECONNECT_ATTEMPTS = 10;
  const STABLE_CONNECTION_DELAY = 5000; // 5 seconds of stable connection before reset

  const socketRef = useRef(null);
  const auctionSocketRoom = `auction:${id}`;

  if (!socketRef.current) {
    socketRef.current = io(URL, {
      query: { token: AccessToken },
      transports: ["websocket"],
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: MAX_RECONNECT_ATTEMPTS,
      reconnectionDelay: 2000,
      timeout: 10000,
      forceNew: false,
    });
  }

  const handleJoinAuction = useCallback(() => {
    console.log("✅ Connected to server");
    socketRef.current.emit("JoinAuction", {
      room: auctionSocketRoom,
    });
  }, [auctionSocketRoom]);

  const toastError = useCallback((message) => showBidErrorToast(message), []);

  //Fetch Proxy Bid List
  const getProxyBidList = useCallback(
    async (stockUnitId, auctionId) => {
      if (!stockUnitId || !auctionId) {
        console.warn("Missing stockUnitId or auctionId for proxy bid fetch");
        return;
      }

      try {
        const params = { stock_unit_id: stockUnitId, auction_id: auctionId };
        const response = await withAuth.getDataWithAuth("/api/proxy-bid/v2", params);

        if (response?.status === 200 && response?.data?.status) {
          // Handle new API response structure
          const proxyBidData = response.data.data?.data || [];
          setProxyList(
            proxyBidData.map((el) => ({
              id: el.id,
              stock_unit_id: el.stock_unit_id,
              buyer_id: el.buyer_id,
              offer_price: parseInt(el.offer_price),
              buyer_nipl_id: el.nipl?.id || null,
              nipl: el.nipl || null,
              buyer: el.buyer || null,
              is_cancelled: false, // Default value, update if API provides this
            }))
          );
        } else {
          setProxyList([]);
          toastError("Failed to fetch proxy bid data");
        }
      } catch (error) {
        console.error("Error fetching proxy bid:", error);
        toastError("Failed to fetch proxy bid data");
        setProxyList([]);
      }
    },
    [toastError]
  );

  // Optimized data processing utilities
  const getBidderDisplayName = useCallback((bidder, thisUser) => {
    // Cek apakah bidder adalah user saat ini berdasarkan user_id
    const isCurrentUser = bidder?.buyer_user_id && bidder?.buyer_user_id === thisUser?.id;
    return isCurrentUser && bidder?.email !== "Proxy bid" ? "Saya" : bidder?.type || "-";
  }, []);

  const processBidderData = useCallback((bidders) => {
    if (!bidders || bidders.length === 0) return { highestBid: null, biddingList: [] };

    const processedBidders = bidders
      .slice()
      .reverse()
      .map((bidder) => {
        // Preserve "Proxy bid", "Proxy bidder", and "Offline Bidder" as-is, otherwise mark as "Online Bidder"
        let type = "Online Bidder";
        if (bidder.email === "Proxy bid" || bidder.email === "Proxy bidder") {
          type = "Proxy bid";
        } else if (bidder.email === "Offline Bidder") {
          type = "Offline Bidder";
        }

        return {
          ...bidder,
          type,
          offer_price: parseInt(bidder.offer) || 0,
          buyer_user_id: bidder.user_id || null,
        };
      });

    const highestBid = {
      email: processedBidders[0]?.email || "",
      buyer_user_id: processedBidders[0]?.buyer_user_id || null,
      offer_price: parseInt(processedBidders[0]?.offer_price) || 0,
      type: processedBidders[0]?.type || "Harga Dasar",
    };

    const biddingList = processedBidders.filter((_, idx) => idx !== 0);

    return { highestBid, biddingList };
  }, []);

  const handleSocketAuction = useCallback(
    (auctionData, skipTotalNiplUpdate = false) => {
      try {
        const currentAuction = auctionData?.auction || {};

        // Only update auction status if auction object exists
        if (auctionData?.auction) {
          if (currentAuction?.status === "CLOSED") {
            setIsOpen(false);
          }

          setAuction({
            ...currentAuction,
            nipls_count: auctionData?.auction_nipls?.length || 0,
          });
          setLiveAuction(currentAuction?.status);

          // Check if auction is STARTED but seconds_left_before is 0 (selecting winner state)
          if (
            currentAuction?.status === "STARTED" &&
            (auctionData?.seconds_left_before === 0 || auctionData?.seconds_left_before === null)
          ) {
            setIsSelectingWinner(true);
          } else {
            setIsSelectingWinner(false);
          }
        }

        // Dispatch lot data to Redux for header dropdown
        // Time Bid uses current_unit array, fallback to all_lot for compatibility
        const lotData = auctionData?.current_unit || auctionData?.all_lot;
        if (lotData && Array.isArray(lotData)) {
          dispatch(actionsLiveAuction.setAllLots({ allLots: lotData }));
        }

        if (auctionData?.current_unit !== null) {
          let unitNow = findUnitById(auctionData?.current_unit, unitId);

          // Normalize data structure untuk kompatibilitas
          const normalizedUnit = {
            ...unitNow,
            // Map stock_only_value_informations ke stock_informations jika tidak ada
            stock_informations: unitNow?.stock_informations || unitNow?.stock_only_value_informations || [],
            // Map stock_document_only_value ke stock_documents jika tidak ada
            stock_documents: unitNow?.stock_documents || unitNow?.stock_document_only_value || [],
          };

          // Get bidders from the correct source - check multiple possible locations
          let bidders = normalizedUnit?.bidders;

          setData(normalizedUnit);
          // Get all lots for "Lot Lainnya" - use current_unit for Time Bid, fallback to all_lot
          // Filter out the currently displayed lot
          const lotsForNextLot = (auctionData?.current_unit || auctionData?.all_lot || []).filter(
            (lot) => String(lot.id) !== String(unitId)
          );
          setAllNextLots(lotsForNextLot); // Store all lots
          setNextLots(lotsForNextLot.slice(0, 4)); // Show only first 4 by default
          setImages(normalizedUnit?.pictures);

          // Process bidder data using utility function with the correct bidders source
          const { highestBid: processedHighestBid, biddingList: processedBiddingList } = processBidderData(bidders);

          const newHighestBid = processedHighestBid || {
            email: "base_price",
            type: "Harga Dasar",
            offer_price: normalizedUnit?.base_price || 0,
          };

          setHighestBid(newHighestBid);
          setBiddingList(processedBiddingList);

          // Safe access to multiple_bid with fallback to existing auction state
          const multipleBidAmount = currentAuction?.unit_type?.multiple_bid || auction?.unit_type?.multiple_bid || 0;
          setMultipleBid(multipleBidAmount);

          // Calculate next offer based on highest bid or base price
          let nextOffer = 0;
          const basePrice = parseInt(normalizedUnit?.base_price) || 0;

          // Check if there are actual bids (not just base price)
          const hasActualBids = newHighestBid?.type !== "Harga Dasar" && newHighestBid?.email !== "base_price";

          if (hasActualBids && newHighestBid?.offer_price > 0) {
            // If there's a real bid, add multiple_bid to it
            nextOffer = newHighestBid.offer_price + multipleBidAmount;
          } else {
            // If no bids yet, use base price without adding multiple_bid
            nextOffer = basePrice;
          }
          setOffer(nextOffer);

          setBlockBid("off");
        }

        // Update key and counter only once at the end of the function
        setKey((prev) => prev + 1);
        setCounter(auctionData?.seconds_left_before || null);

        // Only update total_nipl if not skipped (skip for SendBidResponse)
        if (!skipTotalNiplUpdate) {
          setTotalNipl(auctionData?.total_nipl || 0);
        }

        setUnitLoader(false);
        setBidLoader(false);
        setNextUnitLoader(false);
      } catch (error) {
        console.error("❌ Error in handleSocketAuction:", error);
        console.error("❌ Error stack:", error.stack);
        // Don't throw, just log to prevent blank screen
      }
    },
    [unitId, processBidderData, dispatch, auction]
  );

  const findUnitById = (list, id) => {
    if (!Array.isArray(list)) return null;
    const target = Number.isNaN(Number(id)) ? String(id) : Number(id);
    return (
      list.find((u) => {
        if (u == null) return false;
        if (typeof u.id === "number" && typeof target === "number") return u.id === target;
        return String(u.id) === String(target);
      }) ?? null
    );
  };

  // Handler
  const changeOffer = (val) => {
    const value = parseInt(val);
    let newError = "";

    if (!val || isNaN(value) || value <= 0) {
      newError = "Penawaran tidak boleh kosong atau tidak valid";
    } else if (value < highestBid.offer_price) {
      newError = `Penawaran harus lebih besar dari penawaran saat ini`;
    } else if (multipleBid > 0 && value % multipleBid !== 0) {
      newError = `Penawaran harus kelipatan ${multipleBid.toLocaleString()}`;
    } else {
      newError = "";
    }

    setError(newError);
    setOffer(value || 0);
  };

  const bidHandler = () => {
    if (disableBid === "off") {
      setDisabledBid("on");
    } else {
      setDisabledBid("off");
    }
  };

  const postBid = async () => {
    setIsProcess("on");
    if (responErrorBid.response === slowerBidder && responErrorBid.offer_price === offer) {
      toastError(slowerBidder);
      setIsProcess("off");
      return;
    }
    if (responErrorBid.response === niplOutOfStock) {
      toastError(niplOutOfStock);
      setIsProcess("off");
      return;
    }
    if (highestBid?.email === thisUser?.email) {
      toastError("Bid Anda sudah paling atas!");
      setIsProcess("off");
      return;
    }

    if (error.length > 0) {
      toastError(error);
      setIsProcess("off");
      return;
    }

    try {
      const params = {
        room: auctionSocketRoom,
        offer: offer,
        unit_id: Number(unitId),
        is_conductor: false,
        is_master: 0,
      };

      const response = await withAuth.postDataWithAuth("/api/auction-live/send-bid", params);

      if (response?.status === 200 && response?.data?.status) {
        // Emit TotalNipl only on first bid or after NextLot
        if (shouldEmitTotalNipl.current && id) {
          socketRef.current.emit("TotalNipl", {
            auction_id: parseInt(id, 10),
            unit_id: Number(unitId),
          });
          shouldEmitTotalNipl.current = false; // Disable for subsequent bids
        }

        // Show success notification
        toast.success("Penawaran berhasil dikirim", {
          id: "bid-success-message",
          duration: 3000,
        });
      } else {
        // Handle error response from API
        let errorMessage = "Gagal mengirim penawaran";

        if (response?.data?.errors?.details) {
          errorMessage = response.data.errors.details;
        } else if (response?.data?.message) {
          errorMessage = response.data.message;
        }

        toastError(errorMessage);
      }
    } catch (error) {
      console.error("Error sending bid:", error);

      // Parse error from catch block
      let errorMessage = "Gagal mengirim penawaran";

      if (error?.response?.data?.errors?.details) {
        errorMessage = error.response.data.errors.details;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      toastError(errorMessage);
    } finally {
      setIsProcess("off");
    }
  };

  const secondsToTime = (secs) => {
    if (!secs || secs <= 0) return "00:00:00";

    const days = Math.floor(secs / (24 * 60 * 60));
    const remainingAfterDays = secs % (24 * 60 * 60);

    const hours = Math.floor(remainingAfterDays / (60 * 60));
    const remainingAfterHours = remainingAfterDays % (60 * 60);

    const minutes = Math.floor(remainingAfterHours / 60);
    const seconds = Math.ceil(remainingAfterHours % 60);

    // Format: "1d 10:21:22" if >= 24 hours, otherwise "10:21:22"
    if (days > 0) {
      return `${days}h ${zeroPad(hours)}:${zeroPad(minutes)}:${zeroPad(seconds)}`;
    }

    return `${zeroPad(hours)}:${zeroPad(minutes)}:${zeroPad(seconds)}`;
  };

  // Consolidated date formatting utilities
  const formatAuctionDate = useCallback((dateStart, timeStart, formatType = "date") => {
    if (!dateStart || !timeStart) return "-";

    const dateString = `${dateStart} ${timeStart}`;
    const dateObj = new Date(dateString);

    if (isNaN(dateObj)) return "-";

    switch (formatType) {
      case "date":
        return format(dateObj, "dd MMM yyyy");
      case "time":
        return format(dateObj, "HH:mm");
      default:
        return "-";
    }
  }, []);

  const formatAuctionTimeRange = useCallback(
    (dateStart, timeStart, timeFinish) => {
      const startTime = formatAuctionDate(dateStart, timeStart, "time");
      const endTime = formatAuctionDate(dateStart, timeFinish, "time");

      if (startTime === "-" || endTime === "-") return "-";

      return `${startTime} - ${endTime} WIB`;
    },
    [formatAuctionDate]
  );

  // Consolidated UI components
  const UnitInformation = useCallback(({ informations, documents }) => {
    const allInfo = [
      ...(informations?.filter((el) => el.value !== "") || []),
      ...(documents?.filter((el) => el.value !== "") || []),
    ];

    return (
      <div
        className="unit-information-wrapper"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          gap: "8px",
        }}
      >
        {allInfo.length > 0
          ? allInfo.map(({ label, value }, idx) => (
              <div className="informasi-unit-auction" key={`information-${idx + 1}`}>
                <span className="title">{label}</span>
                <span className="value">
                  {isDate(value) ? moment(value).format("DD MMM YYYY") : value !== "null" && value ? value : "-"}
                </span>
              </div>
            ))
          : ""}
      </div>
    );
  }, []);

  const ResponsiveBidderDisplay = useCallback(
    ({ highestBid, thisUser }) => {
      const bidderName = getBidderDisplayName(highestBid, thisUser);

      return (
        <>
          {/* Desktop view */}
          <div className="d-none d-md-block px-4 pb-4">
            <div className="highest-bid border" style={{ borderRadius: "0.5rem" }}>
              <span className="bid-value">
                Rp {highestBid?.offer_price ? highestBid?.offer_price?.toLocaleString() : "-"}
              </span>
              <span className="bidder">{bidderName}</span>
            </div>
          </div>
          {/* Mobile view */}
          <div className="d-block d-md-none px-4 pb-4">
            <div className="highest-bid d-flex border" style={{ borderRadius: "0.5rem" }}>
              <span className="bid-value" style={{ fontSize: "20px" }}>
                Rp {highestBid?.offer_price ? highestBid?.offer_price?.toLocaleString() : "-"}
              </span>
              <span className="bidder" style={{ fontSize: "16px" }}>
                {bidderName}
              </span>
            </div>
          </div>
        </>
      );
    },
    [getBidderDisplayName]
  );

  // Optimized data processing utilities
  const processUnitDetails = useCallback((item) => {
    const unitInformations = (item?.unit_informations || []).filter(info => info.is_visible !== 0);
    const unitDocuments = item?.unit_documents || [];

    const year = unitInformations.find((info) => info.label === "Tahun");
    const odometer = unitInformations.find((info) => info.label === "Odometer");
    const transmisi = unitInformations.find((info) => info.label === "Transmisi");
    const fuel = unitInformations.find((info) => info.label === "Bahan Bakar");
    const validityPeriod = unitDocuments.find((doc) => doc.label === "STNK");

    return {
      police_number: item?.police_number,
      year: year?.value,
      odometer: odometer?.value,
      transmisi: transmisi?.value,
      fuel: fuel?.value,
      validityPeriod: validityPeriod?.additional_value,
    };
  }, []);

  // Consolidated socket event handlers
  const handleSocketEvent = useCallback(
    (eventType, response) => {
      console.log(`📩 ${eventType}:`, response);

      // Validate response data (skip validation for TotalNiplResponse as it has different structure)
      if (eventType !== "TotalNiplResponse" && !response?.data) {
        console.warn(`⚠️ ${eventType}: Invalid response data`);
        return;
      }

      // Update auction state first (skip for TotalNiplResponse as it doesn't have auction data)
      // For SendBidResponse, skip total_nipl update
      if (eventType !== "TotalNiplResponse") {
        const skipTotalNiplUpdate = eventType === "SendBidResponse";
        handleSocketAuction(response.data, skipTotalNiplUpdate);
      }

      // Handle specific event logic
      switch (eventType) {
        case "SendBidResponse": {
          let currentUnit = null;

          // Priority 1: Check in current_unit (contains detailed info like bidders)
          if (Array.isArray(response?.data?.current_unit)) {
            currentUnit = response.data.current_unit.find((unit) => String(unit.id) === String(unitId));
            // Fallback to first unit if specific ID not found
            if (!currentUnit && response.data.current_unit.length > 0) {
              currentUnit = response.data.current_unit[0];
            }
          }

          // Priority 2: Check in current_unit or all_lot if not found
          if (!currentUnit && Array.isArray(response?.data?.current_unit)) {
            currentUnit = response.data.current_unit.find((unit) => String(unit.id) === String(unitId));
          }
          if (!currentUnit && Array.isArray(response?.data?.all_lot)) {
            currentUnit = response.data.all_lot.find((unit) => String(unit.id) === String(unitId));
          }

          // No need to show toast here, it's already handled in postBid function
          setIsProcess("off");
          break;
        }

        case "TotalNiplResponse": {
          // Handle NIPL response data
          // Try to get data from different possible structures
          let niplData = response?.data?.data || response?.data;
          const remaining = niplData.total_nipl;

          if (niplData && niplData.total_nipl !== undefined) {
            setSpecialNIPLToggle((prev) => {
              // Only update if prev is an object (not false)
              if (typeof prev === "object" && prev !== null) {
                const newState = {
                  ...prev,
                  remaining_nipls: remaining,
                  used_nipls_this_stock_unit: niplData.in_use || 0,
                };
                console.log("📊 New SpecialNIPLToggle state:", newState);
                return newState;
              }
              return prev; // Keep current state if not an object
            });
          } else {
            console.warn("⚠️ TotalNiplResponse: Could not find NIPL data", response);
          }
          break;
        }

        case "JoinAuctionResponse":
        case "PendingResponse":
        case "StartAuctionResponse": {
          // Request NIPL count when joining or starting auction
          if (response.data.auction?.id && response.data.auction?.status === "STARTED") {
            socketRef.current.emit("TotalNipl", {
              auction_id: response.data.auction.id,
              unit_id: Number(unitId),
            });
          }
          break;
        }

        default:
          console.log(`ℹ️ Unhandled event type: ${eventType}`);
          break;
      }
    },
    [thisUser?.email, unitId, handleSocketAuction]
  );

  const handleSocketError = useCallback(
    (err) => {
      console.log("❌ error:", err);

      // Parse error message with priority:
      // 1. errors.details (specific error detail from nested errors object)
      // 2. message (general error message)
      // 3. err.message (fallback for standard Error objects)
      let responseDataError = "Terjadi kesalahan";

      // Handle different error structures
      if (err?.errors?.details) {
        // Case: {"errors": {"details": "NIPL Tidak Cukup..."}}
        responseDataError = err.errors.details;
      } else if (err?.message) {
        // Case: {"message": "Internal Server Error"}
        responseDataError = err.message;
      } else if (typeof err === "string") {
        // Case: error is already a string
        responseDataError = err;
      } else if (err?.error) {
        // Case: {"error": "Some error message"}
        responseDataError = err.error;
      }

      const bidFound = errorSendBidMessages.find((element) => element === responseDataError);
      if (bidFound) {
        setResponseErrorBid({
          offer_price: offer,
          response: responseDataError,
        });
      }

      toast.error(responseDataError, {
        id: "error-message",
        duration: 3000,
      });

      // Reset process state when error occurs
      setIsProcess("off");

      // Auto rejoin room after bid error to ensure sync with server
      // Only rejoin if cooldown period has passed to prevent infinite loop
      const now = Date.now();
      const timeSinceLastRejoin = now - lastRejoinOnErrorRef.current;

      if (socketRef.current?.connected && timeSinceLastRejoin >= REJOIN_COOLDOWN_MS) {
        console.log("🔄 Rejoining auction room after bid error...");
        lastRejoinOnErrorRef.current = now;
        setTimeout(() => {
          handleJoinAuction();
        }, 500); // Small delay to ensure error is processed
      } else if (timeSinceLastRejoin < REJOIN_COOLDOWN_MS) {
        console.log(
          `⏳ Rejoin cooldown active. Wait ${Math.ceil((REJOIN_COOLDOWN_MS - timeSinceLastRejoin) / 1000)}s before next rejoin`
        );
      }
    },
    [offer, handleJoinAuction]
  );

  useEffect(() => {
    console.log("🟡 Setting up socket listeners...");

    // Guard clause: ensure socket exists
    if (!socketRef.current) {
      console.warn("⚠️ Socket ref is null, skipping listener setup");
      return;
    }

    // Socket event listeners - define all handlers with proper references
    const handleConnect = () => {
      console.log("✅ Connected to server");
      setSocketStatus("connected");
      handleJoinAuction();

      // Clear any existing timer
      if (stableConnectionTimerRef.current) {
        clearTimeout(stableConnectionTimerRef.current);
      }

      // Reset counter only after stable connection (5 seconds)
      stableConnectionTimerRef.current = setTimeout(() => {
        console.log("🟢 Connection stable, resetting reconnect counter");
        reconnectCountRef.current = 0;
        setReconnectAttempts(0);
        setMaxReconnectReached(false);
      }, STABLE_CONNECTION_DELAY);
    };

    const handleDisconnect = (reason) => {
      console.log("🔌 Disconnected from server:", reason);
      setSocketStatus("disconnected");

      // Clear stable connection timer on disconnect
      if (stableConnectionTimerRef.current) {
        clearTimeout(stableConnectionTimerRef.current);
        stableConnectionTimerRef.current = null;
      }
    };

    const handleReconnect = (attemptNumber) => {
      console.log(`🔄 Reconnected to server (attempt ${attemptNumber})`);
      setSocketStatus("connected");
      handleJoinAuction();

      // Clear any existing timer
      if (stableConnectionTimerRef.current) {
        clearTimeout(stableConnectionTimerRef.current);
      }

      // Reset counter only after stable connection (5 seconds)
      stableConnectionTimerRef.current = setTimeout(() => {
        console.log("🟢 Connection stable, resetting reconnect counter");
        reconnectCountRef.current = 0;
        setReconnectAttempts(0);
        setMaxReconnectReached(false);
      }, STABLE_CONNECTION_DELAY);
    };

    const handleReconnectAttempt = (attemptNumber) => {
      // Increment cumulative counter
      reconnectCountRef.current += 1;
      const totalAttempts = reconnectCountRef.current;

      console.log(`🔄 Reconnection attempt ${totalAttempts} of ${MAX_RECONNECT_ATTEMPTS}`);
      setReconnectAttempts(totalAttempts);
      setSocketStatus("reconnecting");

      if (totalAttempts >= MAX_RECONNECT_ATTEMPTS) {
        console.log("💥 Maximum reconnection attempts reached");
        setMaxReconnectReached(true);
        setSocketStatus("failed");
        // Disconnect socket to stop further attempts
        if (socketRef.current) {
          socketRef.current.disconnect();
        }
      }
    };

    const handleReconnectError = (error) => {
      console.log("❌ Reconnection error:", error);
      setSocketStatus("reconnecting");
    };

    const handleReconnectFailed = () => {
      console.log("💥 Reconnection failed");
      setSocketStatus("failed");
      setMaxReconnectReached(true);
    };

    const handleConnectError = (err) => {
      console.log("❌ Connection error:", err.message);
    };

    // Define all event handlers with proper references for cleanup
    const handleJoinAuctionResponse = (response) => handleSocketEvent("JoinAuctionResponse", response);
    const handleStartAuctionResponse = (response) => handleSocketEvent("StartAuctionResponse", response);
    const handleTotalNiplResponse = (response) => handleSocketEvent("TotalNiplResponse", response);
    const handlePendingResponse = (response) => handleSocketEvent("PendingResponse", response);
    const handleReSellResponse = (response) => handleSocketEvent("ReSellResponse", response);
    const handleSendBidResponse = (response) => handleSocketEvent("SendBidResponse", response);

    // Event listeners
    const handlePong = (latency) => setLatencyMs(latency);
    socketRef.current.on("connect", handleConnect);
    socketRef.current.on("pong", handlePong);
    socketRef.current.on("disconnect", handleDisconnect);
    socketRef.current.on("reconnect", handleReconnect);
    socketRef.current.on("reconnect_attempt", handleReconnectAttempt);
    socketRef.current.on("reconnect_error", handleReconnectError);
    socketRef.current.on("reconnect_failed", handleReconnectFailed);
    socketRef.current.on("connect_error", handleConnectError);

    socketRef.current.on("JoinAuctionResponse", handleJoinAuctionResponse);
    socketRef.current.on("StartAuctionResponse", handleStartAuctionResponse);
    socketRef.current.on("TotalNiplResponse", handleTotalNiplResponse);
    socketRef.current.on("PendingResponse", handlePendingResponse);
    socketRef.current.on("ReSellResponse", handleReSellResponse);
    socketRef.current.on("SendBidResponse", handleSendBidResponse);
    socketRef.current.on("error", handleSocketError);

    // Connect if not already connected
    if (!socketRef.current.connected) {
      console.log("🔄 Attempting to connect...");
      socketRef.current.connect();
    }

    return () => {
      console.log("🛑 Cleaning up socket listeners...");

      // Clear stable connection timer
      if (stableConnectionTimerRef.current) {
        clearTimeout(stableConnectionTimerRef.current);
        stableConnectionTimerRef.current = null;
      }

      // Remove all listeners with proper function references
      if (socketRef.current) {
        socketRef.current.off("connect", handleConnect);
        socketRef.current.off("pong", handlePong);
        socketRef.current.off("disconnect", handleDisconnect);
        socketRef.current.off("reconnect", handleReconnect);
        socketRef.current.off("reconnect_attempt", handleReconnectAttempt);
        socketRef.current.off("reconnect_error", handleReconnectError);
        socketRef.current.off("reconnect_failed", handleReconnectFailed);
        socketRef.current.off("connect_error", handleConnectError);

        socketRef.current.off("JoinAuctionResponse", handleJoinAuctionResponse);
        socketRef.current.off("StartAuctionResponse", handleStartAuctionResponse);
        socketRef.current.off("TotalNiplResponse", handleTotalNiplResponse);
        socketRef.current.off("PendingResponse", handlePendingResponse);
        socketRef.current.off("ReSellResponse", handleReSellResponse);
        socketRef.current.off("SendBidResponse", handleSendBidResponse);
        socketRef.current.off("error", handleSocketError);
      }
    };
  }, [handleJoinAuction, handleSocketEvent, handleSocketError]);

  // Handle room changes when id changes
  useEffect(() => {
    if (socketRef.current && socketRef.current.connected) {
      console.log("🔄 Room changed, rejoining auction...");
      handleJoinAuction();
    }
  }, [id, handleJoinAuction]);

  // Cleanup socket on component unmount
  useEffect(() => {
    return () => {
      console.log("🛑 Component unmounting, disconnecting socket...");
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
      // Cleanup join room timeout
      if (joinRoomTimeoutRef.current) {
        clearInterval(joinRoomTimeoutRef.current);
        joinRoomTimeoutRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (prevUnitId.current !== auction.current_stock_unit_id) {
      setUnitLoader(true);
      setBidLoader(true);
      setNextUnitLoader(true);
    }

    prevUnitId.current = auction?.current_stock_unit_id;
  }, [auction]);

  useEffect(() => {
    let timer = null;

    if (counter > 0) {
      timer = setInterval(() => setCounter((prev) => prev - 1), 1000);
      setIsOpen(false);
      setIsSelectingWinner(false);
      
      // Clear join room interval when counter is running
      if (joinRoomTimeoutRef.current) {
        clearInterval(joinRoomTimeoutRef.current);
        joinRoomTimeoutRef.current = null;
      }
    }

    if (counter === 0) {
      dispatch(actionsLiveAuction.setCurrentDataUnit({ unit: data }));
      setDataModal((prev) => ({
        ...prev,
        lot_number: auction?.auction_lane_name || "",
      }));

      // Show selecting winner modal if auction is still STARTED
      if (liveAuction === "STARTED") {
        setIsSelectingWinner(true);
        setResult("LOADING");
        setIsOpen(false);
      } else if (liveAuction !== "CLOSED") {
        setResult("LOADING");
        setIsOpen(true);
        setIsSelectingWinner(false);
      }

      // Join room again every 10 seconds when timer reaches 00 and auction is still STARTED
      if (liveAuction === "STARTED" && socketRef.current && socketRef.current.connected) {
        // Only create interval if it doesn't exist yet
        if (!joinRoomTimeoutRef.current) {
          console.log("🔄 Timer reached 00 and auction STARTED, setting up interval to rejoin auction room every 10 seconds...");
          joinRoomTimeoutRef.current = setInterval(() => {
            console.log("🔄 Rejoining auction room (waiting for CLOSED status)...");
            handleJoinAuction();
          }, 10000);
        }
      } else {
        // Clear interval if auction is no longer STARTED
        if (joinRoomTimeoutRef.current) {
          clearInterval(joinRoomTimeoutRef.current);
          joinRoomTimeoutRef.current = null;
        }
      }
    } else if (counter <= 3) {
      setBlockBid("on");
      setColor("secondary");
    } else if (counter <= 5) {
      setColor("danger");
    } else if (counter <= 10) {
      setColor("orange");
    } else if (counter <= 15) {
      setColor("warning");
    } else if (counter > 15) {
      setColor("success");
    }

    return () => {
      if (timer) clearInterval(timer);
      // Don't clear joinRoomTimeoutRef here - let it run until auction is CLOSED
    };
  }, [counter, data, auction, liveAuction, dispatch, handleJoinAuction]);

  useEffect(() => {
    localStorage.removeItem(`highBidTA-${id}-${unitId}`);
    localStorage.removeItem(`listBidderTA-${id}-${unitId}`);
  }, [unitId, id]);

  // Fetch proxy bid list when unit or auction changes
  useEffect(() => {
    if (unitId && id) {
      getProxyBidList(unitId, id);
    }
  }, [unitId, id, getProxyBidList]);

  useEffect(() => {
    let blocked = "off";
    if (proxyList?.length > 0) {
      // Filter proxy yang tidak dibatalkan dan cari yang tertinggi
      const activeProxies = proxyList?.filter((proxy) => !proxy.is_cancelled) || [];
      if (activeProxies.length > 0) {
        const highestProxy = activeProxies.reduce((highest, current) =>
          current.offer_price > highest.offer_price ? current : highest
        );
        if (highestProxy.offer_price > highestBid?.offer_price) {
          blocked = "on";
        }
      }
    }
    setBlockBid(blocked);
  }, [highestBid.offer_price, proxyList]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && socketRef.current && socketRef.current.connected) {
        console.log("👁️ Page became visible, rejoining auction...");
        handleJoinAuction();
      }
    };

    const handleFocus = () => {
      if (socketRef.current && socketRef.current.connected) {
        console.log("🎯 Window focused, rejoining auction...");
        handleJoinAuction();
      }
    };

    const handleOnline = () => {
      console.log("🌐 Network back online, reconnecting...");
      if (socketRef.current && !socketRef.current.connected) {
        socketRef.current.connect();
      }
    };

    const handleOffline = () => {
      console.log("📴 Network offline");
    };

    // Add event listeners
    window.addEventListener("focus", handleFocus);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [handleJoinAuction]);

  const isReady = useMemo(() => !bidLoader && !unitLoader && !nextUnitLoader, [bidLoader, unitLoader, nextUnitLoader]);

  // Socket status indicator
  const getSocketStatusColor = () => {
    switch (socketStatus) {
      case "connected":
        return socketConnected;
      case "connecting":
        return socketReconnecting;
      case "reconnecting":
        return socketDisconnected;
      case "disconnected":
        return socketError;
      case "failed":
        return socketUnknown;
      default:
        return socketUnknown;
    }
  };

  const getSocketStatusText = () => {
    switch (socketStatus) {
      case "connected":
        return "Terhubung";
      case "connecting":
        return "Menghubungkan...";
      case "reconnecting":
        return `Mencoba ulang... (${reconnectAttempts}/${MAX_RECONNECT_ATTEMPTS})`;
      case "disconnected":
        return "Terputus";
      case "failed":
        return maxReconnectReached ? "Koneksi gagal" : "Gagal terhubung";
      default:
        return "Tidak diketahui";
    }
  };

  const handleRefreshPage = () => {
    window.location.reload();
  };

  return (
    <>
      {/* Latency koneksi saat terhubung */}
      {socketStatus === "connected" && <ConnectionLatency latencyMs={latencyMs} />}

      {/* Socket Status Indicator */}
      {socketStatus !== "connected" && (
        <div
          style={{
            position: "fixed",
            top: "10px",
            right: "10px",
            background: getSocketStatusColor(),
            color: textWhite,
            padding: "8px 16px",
            borderRadius: "4px",
            fontSize: "14px",
            zIndex: 9999,
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          }}
        >
          {getSocketStatusText()}
        </div>
      )}

      {/* Max Reconnect Reached Modal */}
      {maxReconnectReached && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
          }}
        >
          <div
            style={{
              background: textWhite,
              padding: "30px",
              borderRadius: "8px",
              maxWidth: "400px",
              textAlign: "center",
              boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
            }}
          >
            <div style={{ marginBottom: "20px" }}>
              <Warning color={danger} width="48" height="48" />
            </div>
            <h3 style={{ color: textDark, marginBottom: "15px" }}>Koneksi Terputus</h3>
            <p
              style={{
                color: textDark,
                marginBottom: "25px",
                lineHeight: "1.5",
              }}
            >
              Koneksi ke server telah terputus setelah {MAX_RECONNECT_ATTEMPTS} kali percobaan. Silakan refresh halaman
              untuk mencoba kembali.
            </p>
            <Button
              variant="primary"
              onClick={handleRefreshPage}
              style={{
                padding: "10px 30px",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              Refresh Halaman
            </Button>
          </div>
        </div>
      )}

      {liveAuction === "STARTED" ? (
        <>
          {isReady ? (
            <>
              <div className="page h-100 pb-3">
                <Container>
                  <Row>
                    <Col md={5}>
                      <div className="box-border mt-15">
                        <div className="unit-slider w-100">
                          <CarouselLayout className="dots-left" dots={true} adaptiveHeight={true}>
                            {images.length > 0 ? (
                              images.slice(0, 5).map((image, i) => (
                                <div key={"img" + i}>
                                  <img
                                    className="with-background detail-unit-slider"
                                    src={image.image_url || image.image}
                                    alt={`Unit preview ${i + 1}`}
                                    style={{
                                      height: "auto",
                                      width: "100%",
                                      display: "block",
                                    }}
                                    onError={(e) => {
                                      e.target.src = defaultImage;
                                    }}
                                  />
                                </div>
                              ))
                            ) : (
                              <div style={{ height: "222px" }}>
                                <div
                                  className="with-background detail-unit-slider"
                                  style={{
                                    background: defaultImage ? `url(${defaultImage})` : "",
                                    height: "100%",
                                    width: "100%",
                                    objectFit: "contain",
                                    minHeight: 200,
                                  }}
                                ></div>
                              </div>
                            )}
                          </CarouselLayout>

                          <div className="grade-desktop d-none d-md-block  ">
                            {data?.unit_inspection?.grade && (
                              <p className="nomor-lot ">
                                Grade
                                <span>{data?.unit_inspection?.grade}</span>
                              </p>
                            )}
                          </div>
                          {/* mobile view */}
                          <div className="d-block d-md-none position-absolute top-0 left-0">
                            <div className="badge-lot">
                              <span className="nomor-lot me-2">
                                Lot{" "}
                                {auction?.auction_lane_name && data?.lot_number
                                  ? auction?.auction_lane_name + data?.lot_number
                                  : "-"}
                              </span>
                              {data?.unit_inspection?.grade && (
                                <span className="nomor-lot">Grade {data?.unit_inspection?.grade || "-"}</span>
                              )}

                              {data.number_of_nipl > 1 && (
                                <span className="nomor-lot nipl">
                                  <span className="icon-nipl">
                                    <SpecialNIPL />
                                  </span>
                                  Special NIPL
                                </span>
                              )}
                            </div>
                          </div>

                          {/* desktop view */}
                          <div className="grade-unit-auction d-none d-md-absolute">
                            Grade
                            <br />
                            <span className="grade-auction">{data?.unit_inspection?.grade || "-"}</span>
                          </div>
                        </div>
                        <div className="d-none d-md-block">
                          <h2 className="unit-name-auction">{data?.unit_name || ""}</h2>
                          {data?.tags?.length > 0 ? (
                            <div>
                              <span className="unit-title">Highlight</span>
                              <div className="unit-highlight mt-2">
                                {data?.tags?.length > 0
                                  ? data?.tags.map((row, i) => <span key={"tag" + i}>{row.name}</span>)
                                  : "-"}
                              </div>
                            </div>
                          ) : null}
                          <span className="unit-title">Detail Kendaraan</span>
                          <UnitInformation informations={data?.stock_informations} documents={data?.stock_documents} />
                        </div>
                      </div>
                    </Col>
                    <Col md={7}>
                      <div className="mt-18">
                        <div className="d-none d-md-block">
                          <div className="badge-lot">
                            <span className="nomor-lot">
                              Lot{" "}
                              {auction?.auction_lane_name && data?.lot_number
                                ? auction?.auction_lane_name + data?.lot_number
                                : "-"}
                            </span>
                            {data.number_of_nipl > 1 && (
                              <span className="nomor-lot nipl">
                                <span className="icon-nipl">
                                  <SpecialNIPL />
                                </span>
                                Special NIPL
                              </span>
                            )}
                            <span className="nomor-lot time-bid">Time Bid</span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <span className="unit-title">Harga Dasar</span>
                          <span className="d-inline d-md-none unit-title">Bidder</span>
                        </div>
                        <div className="group">
                          <span
                            className="unit-price"
                            style={{
                              flex: "1",
                              textDecoration:
                                data?.is_cancel_auction && data?.is_cancel_auction !== "0" ? "line-through" : "none",
                              textDecorationColor: "red",
                              textDecorationThickness: "3px",
                            }}
                          >
                            Rp {data?.base_price !== undefined ? data?.base_price?.toLocaleString() : "0"}
                          </span>
                          <span
                            className="count-customer"
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                              padding: "6px 12px",
                              backgroundColor: "#f0f4f8",
                              borderRadius: "20px",
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#374151",
                              border: "1px solid #e5e7eb",
                            }}
                          >
                            <UserIcon style={{ width: "16px", height: "16px" }} />
                            <span>{totalNipl || 0} Orang</span>
                          </span>
                        </div>

                        <div className="bidder-list" style={{ marginTop: "20px" }}>
                          <div className="header flex-column flex-md-row">
                            <span className="title" style={{ textAlign: "left" }}>
                              Harga Penawaran Saat Ini
                            </span>
                            <span className="timer text-center">
                              <TimerIcon />
                              {secondsToTime(counter)}
                            </span>
                          </div>
                          <ResponsiveBidderDisplay highestBid={highestBid} thisUser={thisUser} />
                          <div className="bidder-data d-none d-md-block">
                            {biddingList?.length > 0
                              ? biddingList
                                  ?.filter((bid) => bid?.offer_price !== highestBid?.offer_price)
                                  ?.map((bid, index) => {
                                    const bidderName = getBidderDisplayName(bid, thisUser);
                                    return (
                                      <div
                                        className={`bidder-item ${
                                          getBidderDisplayName(bid, thisUser) === "Saya" && "active"
                                        }`}
                                        key={`bid-${index}`}
                                      >
                                        <span className="bid-value">Rp {bid?.offer_price?.toLocaleString()}</span>
                                        <span className="bidder">{bidderName}</span>
                                      </div>
                                    );
                                  })
                              : (highestBid?.type === "Harga Dasar" || highestBid?.email === "base_price") && (
                                  <div className="bidder-item text-center font-sm text-secondary">
                                    <span className="mx-auto">Belum ada yang melakukan penawaran</span>
                                  </div>
                                )}
                          </div>
                        </div>
                        <div
                          className={`box-border proxy-bid ${
                            proxyList?.filter((v) => !v.is_cancelled).length > 0 ? "d-block" : "d-none"
                          }`}
                          style={{ marginTop: "20px" }}
                        >
                          <span className="title-header">Proxy Bid</span>
                          {proxyList?.filter((v) => !v.is_cancelled).length > 0
                            ? proxyList
                                .filter((v) => !v.is_cancelled)
                                .map((proxy, iddx) => (
                                  <div
                                    className="group"
                                    key={`proxy-${proxy.id || iddx}`}
                                    style={{ display: "flex", alignItems: "center" }}
                                  >
                                    <span
                                      style={{
                                        padding: "5px",
                                        background: "#F9E6E6",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <ProxyBidIcon />
                                    </span>
                                    <span className="no-nipl" style={{ flex: "1" }}>
                                      {proxy?.nipl?.nipl ? `NIPL: ${proxy.nipl.nipl}` : "-"}
                                    </span>
                                    <span className="bidder" style={{ flex: "1", textAlign: "right" }}>
                                      Rp {parseInt(proxy?.offer_price).toLocaleString()}
                                    </span>
                                  </div>
                                ))
                            : ""}
                        </div>

                        <div
                          className="d-none d-md-block box-border form-bid"
                          style={{ marginTop: "20px", overflow: "hidden" }}
                        >
                          {SpecialNIPLToggle &&
                            ((data?.number_of_nipl > 1 &&
                              SpecialNIPLToggle?.remaining_nipls < data?.number_of_nipl &&
                              SpecialNIPLToggle?.used_nipls_this_stock_unit === 0) ||
                              (SpecialNIPLToggle?.remaining_nipls === 0 && data?.number_of_nipl === 1)) && (
                              <div className="alert-nipl">
                                <Warning color={danger} /> Jumlah NIPL Anda tidak cukup untuk melakukan penawaran
                              </div>
                            )}
                          <div className="d-flex tw-justify-between m-2">
                            <span className="title-header">Tawar</span>
                            <div className="coupon-header d-flex">
                              <Coupon />
                              <p className="m-0">
                                NIPL anda: <span>{SpecialNIPLToggle.remaining_nipls || 0}</span>
                              </p>
                            </div>
                          </div>
                          <div className="group">
                            <div style={{ flex: "1" }}>
                              <InputGroup>
                                <InputGroup.Text id="basic-addon1">Rp</InputGroup.Text>
                                <CurrencyInput
                                  id="hargaTawar"
                                  name="offer"
                                  className="form-control"
                                  placeholder="Masukan penawaran"
                                  disabled={disableBid === "off" || blockBid === "on"}
                                  value={offer}
                                  prefix="Rp "
                                  groupSeparator=","
                                  decimalSeparator="."
                                  readOnly
                                  allowDecimals={false}
                                  onValueChange={(value, name) => changeOffer(value)}
                                />
                              </InputGroup>
                              <small className="text-primary">{error}</small>
                            </div>
                          </div>
                          <div className="group flex-center tes" style={{ marginTop: "10px" }}>
                            <div
                              className="d-flex"
                              style={{
                                flexWrap: "wrap",
                                alignItems: "center",
                                textAlign: "left",
                                justifyContent: "space-between",
                                maxWidth: "530px",
                                width: "100%",
                              }}
                            >
                              <div className="d-none d-md-flex align-items-center justify-content-center gap-1 px-3">
                                <Form.Check
                                  className="mx-1"
                                  type="switch"
                                  id="custom-switch"
                                  checked={disableBid === "on"}
                                  onClick={bidHandler}
                                  onChange={bidHandler}
                                />
                                {disableBid === "off" && (
                                  <div className="d-flex align-items-center gap-1">
                                    <LockOn active={disableBid} />
                                    <span className="font-sm" style={{ color: bidDisabledInactive }}>
                                      Nonaktif
                                    </span>
                                  </div>
                                )}
                                {disableBid === "on" && (
                                  <div className="d-flex align-items-center gap-1">
                                    <LockOff active={disableBid} />
                                    <span className="font-sm" style={{ color: bidDisabledActive }}>
                                      Aktif
                                    </span>
                                  </div>
                                )}
                              </div>

                              {data.number_of_nipl > 1 && (
                                <div className="coupon-footer d-flex" style={{ width: "170px", minWidth: "unset" }}>
                                  <Coupon />
                                  <p className="m-0">
                                    <span>{data.number_of_nipl} NIPL</span> untuk menawar
                                  </p>
                                </div>
                              )}
                            </div>
                            <ShadowClickButton
                              color={color}
                              setIsProcess={setIsProcess}
                              disableBid={disableBid}
                              disabled={disableBid === "off" || blockBid === "on" || isProcess === "on"}
                              isProcess={isProcess}
                              postBid={postBid}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>

                {/* ini hanya tampil di mobile */}
                <Container className="d-block d-md-none">
                  <div className="box-lelang p-3" style={{ margin: "20px 0" }}>
                    {data?.tags?.length > 0 ? (
                      <div>
                        <span className="unit-title mt-0">Highlight</span>
                        <div className="unit-highlight">
                          {data?.tags?.length > 0
                            ? data?.tags.map((row, i) => <span key={"tag" + i}>{row.name}</span>)
                            : "-"}
                        </div>
                      </div>
                    ) : null}
                    <span className="unit-title">Detail Kendaraan</span>
                    <div className="bidder-data">
                      <UnitInformation informations={data?.stock_informations} documents={data?.stock_documents} />
                    </div>
                  </div>
                </Container>
                <Container>
                  <Row>
                    <Col md="12">
                      <div
                        className="box-lelang d-none d-md-block"
                        style={
                          data?.current_stock_unit?.unit_type?.banner_url
                            ? {
                                marginTop: "20px",
                                background: `url(${data?.current_stock_unit?.unit_type?.banner_url})`,
                              }
                            : {
                                marginTop: "20px",
                                backgroundImage: `url(${imageCar})`,
                              }
                        }
                      >
                        <div className="group">
                          <div
                            style={{
                              flex: "1",
                              paddingLeft: "20px",
                              paddingTop: "10px",
                            }}
                          >
                            <span className="lelang-title">{auction?.name || "-"}</span>
                            <div className="lelang-date" style={{ color: textDark }}>
                              {formatSimpleDateRange(auction?.date_start, auction?.date_finish)}
                            </div>
                          </div>
                          <div
                            style={{
                              flex: "1",
                              paddingLeft: "20px",
                              paddingTop: "10px",
                            }}
                          >
                            <div className="lelang-time">
                              <Time />{" "}
                              <span>
                                {formatAuctionTimeRange(auction?.date_start, auction?.time_start, auction?.time_finish)}
                              </span>
                            </div>
                            <div className="lelang-location">
                              <Location /> <span>{auction?.location_name || "-"}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="box-lelang d-flex d-md-none" style={{ marginTop: "20px" }}>
                        <div className="d-flex flex-column flex-md-column">
                          <div
                            style={{
                              flex: "1",
                              paddingLeft: "20px",
                              paddingTop: "10px",
                            }}
                          >
                            <span className="lelang-title">{auction?.name || "-"}</span>
                            <div className="lelang-date" style={{ color: textDark }}>
                              {formatAuctionDate(auction?.date_start, auction?.time_start, "date")}
                            </div>
                          </div>
                          <div
                            style={{
                              flex: "1",
                              paddingLeft: "20px",
                              paddingTop: "10px",
                            }}
                          >
                            <div className="lelang-time">
                              <Time />{" "}
                              <span>
                                {formatAuctionTimeRange(auction?.date_start, auction?.time_start, auction?.time_finish)}
                              </span>
                            </div>
                            <div className="lelang-location">
                              <Location /> <span>{auction?.location_name || "-"}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
                <Container>
                  <div className="produk-terkait w-100">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h3>Lot Lainnya</h3>
                      <div className="d-flex" style={{ gap: "8px" }}>
                        {allNextLots?.length > 4 && (
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="d-none d-md-block"
                            onClick={() => {
                              if (showAllLots) {
                                setNextLots(allNextLots.slice(0, 4));
                                setShowAllLots(false);
                              } else {
                                setNextLots(allNextLots);
                                setShowAllLots(true);
                              }
                            }}
                          >
                            {showAllLots ? "Tampilkan Lebih Sedikit" : `Lihat Lainnya (${allNextLots.length - 4}+)`}
                          </Button>
                        )}
                        <Button
                          variant="outline-primary"
                          size="sm"
                          className="d-md-none"
                          onClick={() => setShowSidebar(true)}
                        >
                          Lihat Semua
                        </Button>
                      </div>
                    </div>
                    <CarouselMultipleLayout slideToShow={4} totalItem={nextLots?.length || 0}>
                      {nextLots?.length > 0 ? (
                        nextLots.map((item, idx) => (
                          <LazyLotCard
                            key={`lot-${item?.id || idx}`}
                            item={item}
                            auction={auction}
                            processUnitDetails={processUnitDetails}
                          />
                        ))
                      ) : (
                        <div className="col-md-12 text-center py-4">Tidak ada Lot selanjutnya</div>
                      )}
                    </CarouselMultipleLayout>
                  </div>
                </Container>

                {/* Sidebar Mobile untuk Lot Lainnya */}
                <Offcanvas
                  show={showSidebar}
                  onHide={() => setShowSidebar(false)}
                  placement="end"
                  className="d-md-none"
                  style={{ width: "85%" }}
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Lot Lainnya</Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <div className="d-flex flex-column" style={{ gap: "0.5rem" }}>
                      {allNextLots?.length > 0 ? (
                        allNextLots.map((item, idx) => {
                          const lotNumber = `${auction?.auction_lane_name}${item?.lot_number}` || "-";
                          const unitName = item?.unit_name || "Unit Tidak Diketahui";
                          return (
                            <div
                              key={"sidebar-lot" + idx}
                              style={{
                                cursor: "pointer",
                                padding: "12px 16px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "8px",
                                border: "1px solid #dee2e6",
                                transition: "all 0.2s ease",
                              }}
                              onClick={() => {
                                setShowSidebar(false);
                                window.location.href = `/time-bid-auction/${id}/${item?.id}`;
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#e9ecef";
                                e.currentTarget.style.borderColor = "#adb5bd";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "#f8f9fa";
                                e.currentTarget.style.borderColor = "#dee2e6";
                              }}
                            >
                              <div style={{ fontSize: "14px", fontWeight: "600", color: "#212529" }}>
                                LOT {lotNumber} - {unitName}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <p className="text-center text-muted">Tidak ada Lot selanjutnya</p>
                      )}
                    </div>
                  </Offcanvas.Body>
                </Offcanvas>

                {/* tampil saat mobile */}
                <div
                  className="d-block d-md-none position-fixed w-100 bottom-0 box-border form-bid"
                  style={{ marginTop: "20px", overflow: "hidden", zIndex: 10 }}
                >
                  {SpecialNIPLToggle &&
                    ((data?.number_of_nipl > 1 &&
                      SpecialNIPLToggle?.remaining_nipls < data?.number_of_nipl &&
                      SpecialNIPLToggle?.used_nipls_this_stock_unit === 0) ||
                      (SpecialNIPLToggle?.remaining_nipls === 0 && data?.number_of_nipl === 1)) && (
                      <div className="alert-nipl" style={{ top: "15px", marginTop: -35 }}>
                        <Warning color="#FF4D4D" /> Jumlah NIPL Anda tidak cukup untuk melakukan penawaran
                      </div>
                    )}
                  <div className="d-flex tw-justify-between m-2">
                    <span className="title-header">Tawar</span>{" "}
                    <div className="coupon-header d-flex">
                      <Coupon />
                      <p className="m-0">
                        NIPL anda: <span>{SpecialNIPLToggle.remaining_nipls}</span>
                      </p>
                    </div>
                  </div>
                  <div className="group">
                    <div style={{ flex: "1" }}>
                      <InputGroup>
                        <InputGroup.Text id="basic-addon1">Rp</InputGroup.Text>
                        <CurrencyInput
                          id="hargaTawar"
                          name="offer"
                          className="form-control"
                          placeholder="Masukan penawaran"
                          disabled={disableBid === "off" || blockBid === "on"}
                          value={offer}
                          prefix="Rp "
                          groupSeparator=","
                          decimalSeparator="."
                          readOnly
                          allowDecimals={false}
                          onValueChange={(value, name) => changeOffer(value)}
                        />
                      </InputGroup>
                      <small className="text-primary">{error}</small>
                    </div>
                  </div>
                  <div className="group align-items-center" style={{ marginTop: "10px" }}>
                    <div
                      className="d-flex"
                      style={{
                        flexWrap: "wrap",
                        alignItems: "center",
                        textAlign: "right",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <Form.Check
                          className="ms-1 me-2"
                          type="switch"
                          id="custom-switch"
                          checked={disableBid === "on" ? true : false}
                          onClick={bidHandler}
                          onChange={bidHandler}
                        />
                        <div className={`d-flex align-items-center ml-2`}>
                          {disableBid === "on" ? (
                            <>
                              {" "}
                              <LockOff active={disableBid} />
                              <span
                                className="font-sm ml-1 "
                                style={{
                                  color: disableBid === "on" ? bidDisabledActive : "",
                                }}
                              >
                                Aktif
                              </span>
                            </>
                          ) : (
                            <>
                              <LockOn active={disableBid} />
                              <span
                                className="font-sm ml-1 "
                                style={{
                                  color: disableBid === "off" ? bidDisabledInactive : "",
                                }}
                              >
                                Nonaktif
                              </span>
                            </>
                          )}
                        </div>
                      </div>{" "}
                      {data.number_of_nipl > 1 && (
                        <div className="coupon-footer d-flex">
                          <Coupon />
                          <p className="m-0" style={{ borderRight: "none" }}>
                            <span>{data.number_of_nipl} NIPL</span> untuk menawar
                          </p>
                        </div>
                      )}
                    </div>
                    <ShadowClickButton
                      color={color}
                      setIsProcess={setIsProcess}
                      disableBid={disableBid}
                      disabled={disableBid === "off" || blockBid === "on" || isProcess === "on"}
                      isProcess={isProcess}
                      postBid={postBid}
                    />
                  </div>
                </div>
              </div>
            </>
          ) : (
            <OnlineAuctionSkeleton />
          )}
        </>
      ) : null}
      {liveAuction === "COMING" || liveAuction === "CLOSED" ? <ArtworkPending status={liveAuction} /> : ""}
      {liveAuction === "NOT_FOUND" ? <PageNotFound></PageNotFound> : ""}
      {isOpen ? <ResultLelang status={result} dataAuction={dataModal?.data_unit} isRegular /> : ""}
      {isSelectingWinner ? <ResultLelang status="LOADING" dataAuction={dataModal?.data_unit} isRegular /> : ""}
    </>
  );
}

const ShadowClickButton = ({ disableBid, color, disabled, setIsProcess, isProcess, postBid }) => {
  const COOLDOWN_MS = 1500; // 1.5 seconds
  const cooldownIntervalRef = useRef(null);
  const shadowClickTimeoutRef = useRef(null);

  const [lastApiCall, setLastApiCall] = useState(null);
  const [cooldownRemaining, setCooldownRemaining] = useState(0);

  const updateCooldown = () => {
    if (!lastApiCall) return;

    const now = Date.now();
    const timeSinceLastCall = now - lastApiCall;
    const remaining = Math.max(0, COOLDOWN_MS - timeSinceLastCall);

    setCooldownRemaining(Math.ceil(remaining / 1000));

    if (remaining <= 0 && cooldownIntervalRef.current) {
      clearInterval(cooldownIntervalRef.current);
      cooldownIntervalRef.current = null;
    }
  };

  const startCooldownTimer = () => {
    if (cooldownIntervalRef.current) {
      clearInterval(cooldownIntervalRef.current);
    }

    cooldownIntervalRef.current = setInterval(updateCooldown, 100);
    updateCooldown();
  };

  const handleButtonClick = async () => {
    const now = Date.now();
    const canMakeApiCall = !lastApiCall || now - lastApiCall >= COOLDOWN_MS;

    if (!canMakeApiCall) {
      // Shadow click logic (no API call)
      setIsProcess("on");
      shadowClickTimeoutRef.current = setTimeout(() => {
        setIsProcess("off");
      }, 500);
      return;
    }

    try {
      setIsProcess("on");
      setLastApiCall(now);
      startCooldownTimer();
      await postBid();
    } catch (err) {
      // Error handling is done in postBid function
      // No need to log here as it might expose sensitive information
    } finally {
      setIsProcess("off");
    }
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (cooldownIntervalRef.current) {
        clearInterval(cooldownIntervalRef.current);
      }
      if (shadowClickTimeoutRef.current) {
        clearTimeout(shadowClickTimeoutRef.current);
      }
    };
  }, []);

  return (
    <Button
      className={`${disableBid === "off" ? "bid-off" : "bid-on"}`}
      disabled={disabled}
      onClick={handleButtonClick}
      variant={color}
      style={{ width: "160px" }}
    >
      {isProcess === "on" ? <Spinner animation="border" /> : "Tawar"}
    </Button>
  );
};
